import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { Container, Content, Icon, Text, Visibility } from '../styled';

var Banner = function (_Component) {
  _inherits(Banner, _Component);

  function Banner() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Banner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Banner.__proto__ || _Object$getPrototypeOf(Banner)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: 0
    }, _this.getHeight = function () {
      if (_this.containerRef) _this.setState({ height: _this.containerRef.clientHeight });
    }, _this.innerRef = function (ref) {
      _this.containerRef = ref;
      if (_this.props.innerRef) _this.props.innerRef(ref);
      _this.getHeight();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Banner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appearance = _props.appearance,
          children = _props.children,
          icon = _props.icon,
          isOpen = _props.isOpen;


      return React.createElement(
        Visibility,
        { bannerHeight: this.state.height, isOpen: isOpen },
        React.createElement(
          Container,
          {
            innerRef: this.innerRef,
            appearance: appearance,
            'aria-hidden': !isOpen,
            isOpen: isOpen,
            role: 'alert'
          },
          React.createElement(
            Content,
            { appearance: appearance },
            React.createElement(
              Icon,
              null,
              icon
            ),
            React.createElement(
              Text,
              { appearance: appearance },
              children
            )
          )
        )
      );
    }
  }]);

  return Banner;
}(Component);

Banner.defaultProps = {
  appearance: 'warning',
  isOpen: false
};
export default Banner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/banner/dist/esm/components/Banner.js
// module id = 744
// module chunks = 0